import {
  ref,
  watch,
  computed,
} from 'vue'

import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'

/** @module KP_06-Template */

/**
 * функцию композиции
 * @param {object} param - параметры для композиции
 * @param {function} param.applyTemplate - callback для применепя фильтров в customisationMenu
 * @param {function} param.resetTemplate - callback для сброса фильтров в customisationMenu
 *
 * @returns {object} obj
 */
export default function () {
  const store = useStore()
  const router = useRouter()
  const route = useRoute()

  const goals = computed(() => store.getters['goals/goals'])
  /**
   *
   */
  const selectedPlan = ref(null)
  const selectPlan = (selectedPlan) => {
    router.replace({
      name: route.name,
      params: {
        ...route.params,
        goal: goal.value,
        plan: selectedPlan.type,
      },
    })
  }

  const selectedDay = ref(null)
  const selectDay = (day) => {
    if (day) {
      selectedDay.value = day
      menuDays.value = day.numberOfMealDays
    }
  }
  const menuDays = ref(null)

  const goal = computed(() => {
    if (route.params.goal) {
      return route.params.goal
    }
    // проверка для кастомников с одной целью похудейка (выбрать ее по умолчанию)
    const goalsFiltered = goals.value ? goals.value?.find(goal => goal.id !== 1) : null
    return goalsFiltered ? goalsFiltered?.code : goals.value?.find(goal => goal.id === 1).code
  })

  const plan = computed(() => {
    if (route.params.plan) {
      return route.params.plan
    }
    if (goalInfo.value?.defaultMenuType && goalInfo.value.defaultMenuType !== '') {
      return goalInfo.value.defaultMenuType
    }
    return (goals.value && pricePlansN.value && pricePlansN.value) ? pricePlansN.value[0]?.type : null
  })

  const menuType = computed(() => {
    return plan.value
  })

  const goalInfo = computed(() => {
    if (!goals.value || goals.value.length === 0) return null
    return goals.value.find((target) => target.code === goal.value)
  })

  const pricePlansN = computed(() => {
    if (!goalInfo.value) return []
    return goalInfo.value.menuTypes
  })

  const setSelectedPlan = ([pricePlansN, plan]) => {
    let planInfo = pricePlansN.find((item) => item.type === plan)
    if (!planInfo) {
      planInfo = pricePlansN[0]
    }
    selectedPlan.value = planInfo
  }

  if (pricePlansN.value && plan.value) {
    setSelectedPlan([pricePlansN.value, plan.value])
  }
  watch([pricePlansN, plan], setSelectedPlan, { deep: true })

  const daysN = computed(() => {
    if (!selectedPlan.value) {
      return []
    }
    const days = []
    selectedPlan.value.pricePlan.mealDays.forEach(meal => {
      let price = meal.promoInfo.price ? meal.promoInfo.price : meal.price
      let oldPrice = meal.promoInfo.price ? meal.price : null
      if (meal.subscriptionDays) {
        price = Math.ceil(price / 6)
        oldPrice = oldPrice ? Math.ceil(oldPrice / 6) : null
      }
      days.push({
        local: {
          price,
          oldPrice,
          name: meal.title,
          value: meal.numberOfMealDays,
        },
        ...meal,
      })
    })
    return days
  })

  const defaultDays = computed(() => {
    if (!selectedPlan.value) {
      return null
    }
    const mealDay = selectedPlan.value.pricePlan.mealDays.find(mealDay => mealDay.isDefault)
    return mealDay.subscriptionId_H === '' ? mealDay.numberOfMealDays : mealDay.subscriptionDays
    // return selectedPlan.value.pricePlan.numberOfMealDays
  })

  const setDay = (daysList) => {
    let selectedDay = daysList?.[0]
    // если есть дефолтный поставить его
    if (defaultDays.value) {
      selectedDay = daysList.find((item) => item.numberOfMealDays === defaultDays.value) || daysList?.[0]
    }
    selectDay(selectedDay)
  }
  if (daysN.value) {
    setDay(daysN.value)
  }

  watch(daysN, setDay, { deep: true })

  return {
    // data
    selectedPlan,
    selectedDay,
    menuDays,
    // computed
    goal,
    plan,
    goalInfo,
    pricePlansN,
    menuType,
    daysN,
    // methods
    selectPlan,
    selectDay,
  }
}
